import React, { Fragment, useState } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import LoadingVerticalBars from "Shared/LoadingVerticalBars";

export interface AddVehicleProps {
    loading?: boolean;
    minHeight?: number;
    srpLink?: string;
    toggleOSModal?: () => void;
}

const AddVehicle: React.FunctionComponent<AddVehicleProps & WithTranslation> = ({
    loading,
    minHeight,
    srpLink,
    t,
    toggleOSModal,
}) => {
    const [addingVehicle, setAddingVehicle] = useState(false);
    const handleClick = () => {
        setAddingVehicle(true);
        toggleOSModal && toggleOSModal();
    };
    const content = (
        <Fragment>
            {loading || addingVehicle ? (
                <LoadingVerticalBars />
            ) : (
                <Fragment>
                    <span className="VehicleHeader__add-icon">+</span>
                    <br />
                </Fragment>
            )}
            {t("MyGarage.TableCompare.VehicleHeader.AddVehicle.title")}
        </Fragment>
    );
    return (
        <div
            data-e2e="add-vehicle-container"
            className="VehicleHeader__add"
            style={minHeight ? { height: minHeight } : {}}
        >
            {srpLink && (
                <div className="VehicleHeader__add-content" onClick={handleClick}>
                    <span className="VehicleHeader__add-span">
                        <a className="VehicleHeader__add-link" href={srpLink} target="_top">
                            {content}
                        </a>
                    </span>
                </div>
            )}

            {!srpLink && (
                <div className="VehicleHeader__add-content" onClick={handleClick}>
                    <span className="VehicleHeader__add-span">{content}</span>
                </div>
            )}
        </div>
    );
};

export default withTranslation()(AddVehicle);
